// Collapsible Content

$('.collapse-toggle').on('click', function(){
  $('.collapse-content').toggleClass('showing');
  $('.collapse-toggle svg').toggleClass('showing');
});




setTimeout(function(){
$('#vitals-preorder-note').removeAttr('style');
},1500)

$(document).ready(function () {
  if($('#agree').length == 1){
    $("body").on(
        "click",
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
        function () {
            if ($("#agree").is(":checked")) {
                $(this).submit();
            } else {
                alert(
                    "You must agree with the terms and conditions of sales to check out."
                );
                return false;
            }
        }
    );
  }
//   $(".product-single__form button").on("click",function(){
//     var Data = $(".product-single__form").serialize();
     
//     var params = {
//       type: 'POST',
//       url: '/cart/add.js',
//       data: Data,
//       dataType: 'json',
//       success: function(stuff) {
//       jQuery.post('/cart/update.js',
//       "updates[42289773641987]=1"
//       );
//       }
//     };

//     $.ajax(params);
//     });
  $("a.fancybox").fancybox()
});